import { Guid, Nillable } from '@web/utils';
import {
  BoxQuestionnaireQuestion,
  BoxQuestionnaireStatus,
  OrderNumber,
} from '@web/shared/module/shop';
import { AdminBoxQuestionnaireContextOperations } from './admin-box-questionnaire-context-operations';

export class AdminBoxQuestionnaireDetails {
  public constructor(
    private readonly data: {
      contextOperations: AdminBoxQuestionnaireContextOperations;
      createdAt: Date;
      endDate: Date;
      description?: Nillable<string>;
      id: Guid;
      isShown: boolean;
      logoAlt?: Nillable<string>;
      logoUrl?: Nillable<string>;
      name: string;
      orderId: Guid;
      orderNumber: OrderNumber;
      ownerName: string;
      questions: BoxQuestionnaireQuestion[];
      status: BoxQuestionnaireStatus;
    },
  ) {}

  public get contextOperations(): AdminBoxQuestionnaireContextOperations {
    return this.data.contextOperations;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get endDate(): Date {
    return this.data.endDate;
  }

  public get description(): Nillable<string> {
    return this.data.description;
  }

  public get id(): Guid {
    return this.data.id;
  }

  public get isShown(): boolean {
    return this.data.isShown;
  }

  public get logoAlt(): Nillable<string> {
    return this.data.logoAlt;
  }

  public get logoUrl(): Nillable<string> {
    return this.data.logoUrl;
  }

  public get name(): string {
    return this.data.name;
  }

  public get orderId(): Guid {
    return this.data.orderId;
  }

  public get orderNumber(): OrderNumber {
    return this.data.orderNumber;
  }

  public get ownerName(): string {
    return this.data.ownerName;
  }

  public get questions(): BoxQuestionnaireQuestion[] {
    return this.data.questions;
  }

  public get status(): BoxQuestionnaireStatus {
    return this.data.status;
  }
}
